import { Box, Flex, Heading, Text,Image } from '@chakra-ui/react';
import { fill } from 'lodash';


export default function KshetraYatra({ sectionData }) {
    return (
        <Box w="100%" py={{ base: "10px", md: "80px",xl:"80px" }}>
            <Box key={sectionData.id} position="relative" w="100%" >
                {/* Sun Image Positioned Dynamically */}
                <Box
                    display={{ base: 'none', md: 'block' }} // Hide sun image on small devices
                    position="absolute"
                    top="4%"
                    left={{
                        md:sectionData.textPositionLeft ? 'auto' : '22%', 
                        lg:sectionData.textPositionLeft ? 'auto' : '34%',
                        xl:sectionData.textPositionLeft ? 'auto' : '22%',
                    }}
                    right={{
                        md: sectionData.textPositionLeft ? '14%' : 'auto',
                        lg: sectionData.textPositionLeft ? '28%' : 'auto',
                        xl: sectionData.textPositionLeft ? '14%' : 'auto',
                    }}
                    transform="translate(-50%, -50%)"
                    zIndex={3}
                    w={{ md: "68px", xl: "102px" }}
                    h={{ md: "64px", xl: "100px" }}
                >
                    <Image
                        src="https://www.datocms-assets.com/46272/1733292536-sun.svg"
                        alt="Sun Design"
                        layout="fill" // Makes the image fill the Box dimensions
                        objectFit="contain"
                    />
                </Box>

                <Flex
                    direction={{ base: 'column', md: sectionData.textPositionLeft ? 'row-reverse' : 'row' }} // Stack vertically on small screens
                    justify="center"
                    w="100%"
                    h={{ base: 'auto', md:"380px", xl: '520px' }}
                    position="relative"
                >
                    {/* Image Section */}
                    <Box
                        // w={{ base: '280px', sm: "420px", xl: '439px' }}
                        // h={{ base: '278px', md:"255px", xl: '400px' }}
                        zIndex={2}
                        mx={{ base: "auto" }}
                        position="relative"
                        top={{ base: "40px", md: "73px", lg: "80px", xl:sectionData.textPositionLeft?"108px":"113px" }}
                        {...(sectionData.textPositionLeft
                            ? { right: { base: '0', md:"110px", lg: '188px', xl:"198px" }, left: 'auto' }
                            : { left: { base: '0', md:"85px", lg: '188px', xl: "170px" }, right: 'auto' })}
                    >
                        <Image
                            src={sectionData.image.url}
                            alt={sectionData.image.alt || "Section Image"}
                            w={{ base: '280px', sm: "254px", xl: '439px' }}
                            h={{ base: '278px', md:"255px", xl: '400px' }}
                            // layout={fill}
                        />
                    </Box>

                    {/* Text Content Section */}
                    <Box
                        w={{ base: '100%',md:"580px",xl: '944px' }} 
                        h={{ base: '525px',md:"334px" ,xl: '520px' }} 
                        position="relative"
                        zIndex={1}
                        backgroundImage={{ base: `url('${sectionData.mobileImage?.url}')`, md: `url('${sectionData.bgImage.url}')` }}
                        backgroundSize="contain"
                        backgroundRepeat="no-repeat"
                        backgroundPosition="center"
                        display="flex"
                        flexDirection="column"
                        justifyContent={{ base: "center", xl: "end" }}
                        alignItems="center" // Keeps the container centered but allows child alignment
                        pb={{ xl: "110px" }}
                        pr={{ xl: "120px" }}
                        bottom={{base:"50px",md:"0"}}
                    >
                        <Box
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            alignItems={"flex-start"}// Align child content to the left
                            pl={sectionData.textPositionLeft ? "0" : { base: "0", sm: "10px", md: "90px", lg: "110px", xl: "130px" }}
                            pr={sectionData.textPositionLeft ? { base: "0", md: "90px", lg: "0px", xl: "120px" } : "0"}
                            pt={{ base: sectionData.textPositionLeft ?"80px":"55px", md: sectionData.textPositionLeft ? "38px" : "68px", xl: "0" }}
                        >
                            <Heading
                                as="h2"
                                fontSize={{ base: '28px', xl: '42px' }} // Adjust font size on smaller screens
                                fontWeight="700"
                                fontFamily={"Fedra Serif Display"}
                                color="#ECBD47"
                                width={{ md: "396px" }}
                                h={{ md: "53px" }}
                                mb={{ base: 2, md: 1 }}
                                lineHeight={{ base: "35.28px", xl: "52.92px" }}
                            >
                                {sectionData.title}
                            </Heading>
                            <Text
                                fontSize={{ base: "20px", md: "16px", xl: "20px" }}
                                w={{ base: '280px', md: sectionData.textPositionLeft ? "309px" : "329px", xl: "420px" }}
                                textAlign="left" // Ensure text is left-aligned
                                color="#ffffff"
                                fontFamily="FedraSansStd-book"
                                // fontStyle="italic"
                                lineHeight={{ base: "34px", md: "27.2px", xl: "34px" }}
                            >
                                {sectionData.description}
                            </Text>
                        </Box>
                    </Box>
                </Flex>
            </Box>
        </Box>
    );
}